import { Component, OnInit } from '@angular/core';

import { DEPARTMENT_TYPE_WHEELCHAIR } from 'src/app/core/constants';

@Component({
  selector: 'app-wheelchair-ranking-history',
  templateUrl: './wheelchair-ranking-history.component.html',
  styleUrls: ['./wheelchair-ranking-history.component.scss']
})
export class WheelchairRankingHistoryComponent implements OnInit {
  /**
   * Definição do tipo de departamento para sessão/depto Profissional
   */
  public departmentType: string = DEPARTMENT_TYPE_WHEELCHAIR;

  constructor() { }

  ngOnInit(): void {
  }

}
